import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";

import { acknowledgeReleaseNotes } from "../../actions/playerActions";

class ReleaseNotesModal extends PureComponent {
	render() {

		const { releaseNotes } = this.props;

		if (!releaseNotes || !releaseNotes.showModal) {
			return null;
		}

		const { activityId, version, revision, content, showModal } = releaseNotes;
		return (
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-prompt-modal"
			}}
				open={showModal}
				showCloseIcon={false}
				onClose={() => { }}>
				<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
					<div style={{ color: "white", fontSize: 35, marginLeft: 10, marginTop: 10, marginRight: 10, marginBottom: 3 }}>Release Notes</div>
					<div style={{ color: "white", fontSize: 12, marginLeft: 10, marginBottom: 10, marginRight: 10, borderBottomWidth: 1, borderBottomColor: "gray" }}>Publication Version: {version} (Revision: {revision})</div>
					<div style={{ color: "white", fontSize: 20, margin: 50 }}>{content}</div>
					<div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
						<div style={{ color: "lightgreen", borderColor: "lightgreen", borderStyle: "solid", borderRadius: "10px", fontSize: 24, marginLeft: "15px", padding: "15px", cursor: "pointer" }} onClick={() => { 
							acknowledgeReleaseNotes(activityId, version, revision);
						 }}>Got It!</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export default branch({
	releaseNotes: ["releaseNotes"]
}, ReleaseNotesModal);
